export function createMarkup(dirty: string) {
  return { __html: dirty }
}
